import { Seo } from '@/components/Seo';
import { JsonLd, makeBreadcrumbSchema } from '@/components/Schema';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function Contact() {
  return (
    <>
      <Seo
        title="Contact Us | Free Resume Builder"
        description="Get in touch with the ai-free-resume team."
        path="/contact"
      />
      <JsonLd schema={makeBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Contact', path: '/contact' }])} />

      <section className="bg-white py-20 md:py-28">
        <div className="mx-auto max-w-[600px] px-6 text-center">
          <Link to="/" className="inline-flex items-center gap-2 text-sm font-medium text-[#00D4AA] hover:text-[#00B894]">
            <ArrowLeft size={16} /> Back to Home
          </Link>
          <h1 className="mt-6 text-3xl font-bold text-[#0A2540] md:text-4xl">Contact Us</h1>
          <p className="mt-4 text-lg text-[#4A5568]">
            Have questions or feedback? We'd love to hear from you.
          </p>
          <div className="mt-10">
            <a
              href="mailto:support@ai-free-resume.org"
              className="btn-primary inline-flex items-center justify-center rounded-[10px] px-8 py-4 text-base font-semibold"
            >
              Email support@ai-free-resume.org
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
